var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 0.5,
    width: 40,
    height: 27,
    rx: 2,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79391 8.33579C9.82856 6.94272 11.0755 5.74027 12.465 5.71991C13.8524 5.71565 15.2401 5.71929 16.6276 5.71806C16.6238 10.379 16.6351 15.0404 16.6219 19.7011C16.5684 21.0773 15.3351 22.2568 13.9608 22.2812C12.5707 22.2862 11.1804 22.2819 9.79025 22.2833V16.4651C11.1406 16.7828 12.5566 16.918 13.9341 16.7073C14.7575 16.5754 15.6585 16.1726 15.9372 15.3218C16.1424 14.5941 16.0269 13.8281 16.0574 13.0812V11.3465H13.6735C13.6627 12.4938 13.6954 13.6431 13.6562 14.7889C13.5919 15.4933 12.8916 15.9408 12.2246 15.9169C11.3974 15.9256 9.75822 15.3198 9.75822 15.3198C9.7541 13.1703 9.78222 10.4784 9.79391 8.336V8.33579Z",
    fill: "url(#paint0_linear_8049_71337)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4826 14.3358C27.0843 14.3488 27.6895 14.3093 28.2888 14.3563C28.8957 14.4691 29.042 15.3842 28.5028 15.6839C28.1349 15.8813 27.6978 15.7574 27.2989 15.7923H26.4826V14.3358ZM28.6367 12.6873C28.7704 13.1572 28.3155 13.5792 27.861 13.5145H26.4826C26.4923 13.0713 26.4637 12.5903 26.4966 12.1704C27.0488 12.1859 27.6061 12.1388 28.1551 12.195C28.391 12.254 28.5884 12.4472 28.6367 12.6873ZM31.9542 5.71781C31.9798 6.61532 31.9579 7.56028 31.9652 8.47601C31.9635 12.199 31.9688 15.9219 31.9623 19.6451C31.9381 21.0404 30.6965 22.2528 29.3052 22.2806C27.9126 22.2863 26.5198 22.2815 25.1269 22.2831V16.6547C26.6445 16.6469 28.1628 16.6705 29.6797 16.6429C30.3834 16.5989 31.1542 16.1364 31.187 15.3652C31.2698 14.5906 30.5366 14.0548 29.8404 13.9702C29.5728 13.9633 29.5806 13.8925 29.8404 13.8616C30.5044 13.7187 31.0258 13.0343 30.8304 12.3488C30.664 11.6279 29.8639 11.3488 29.1984 11.3502C27.8414 11.341 26.4842 11.3489 25.1272 11.3463C25.136 10.2955 25.109 9.24362 25.1418 8.19364C25.2493 6.82354 26.5222 5.69365 27.8939 5.71816C29.2475 5.71796 30.6009 5.71796 31.9542 5.71791V5.71781Z",
    fill: "url(#paint1_linear_8049_71337)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5183 12.0455C17.3928 12.072 17.4931 11.6198 17.461 11.4482C17.4696 10.3636 17.4431 9.27775 17.4756 8.19386C17.5828 6.81797 18.8654 5.68526 20.2427 5.71747H24.2987C24.2949 10.3784 24.3061 15.0398 24.293 19.7005C24.2395 21.0767 23.0061 22.2561 21.6317 22.2806C20.2415 22.2858 18.8512 22.2814 17.461 22.2827V15.9081C18.4104 16.684 19.7009 16.8048 20.8838 16.8069C21.7755 16.8066 22.6621 16.6696 23.5281 16.4648V15.297C22.5521 15.7814 21.4049 16.0891 20.323 15.8108C19.5683 15.6237 19.0205 14.8973 19.0327 14.1217C18.9453 13.315 19.42 12.4634 20.216 12.2236C21.2042 11.9155 22.2812 12.1511 23.2075 12.5517C23.406 12.6552 23.6074 12.7836 23.528 12.4532V11.5353C21.9788 11.1682 20.3301 11.0331 18.7737 11.4324C18.3232 11.559 17.8843 11.751 17.5183 12.0456V12.0455Z",
    fill: "url(#paint2_linear_8049_71337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8049_71337",
    x1: 9.64478,
    y1: 14.1593,
    x2: 16.5155,
    y2: 14.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8049_71337",
    x1: 25.0802,
    y1: 13.6462,
    x2: 31.9221,
    y2: 13.6462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8049_71337",
    x1: 17.4509,
    y1: 13.8064,
    x2: 24.2974,
    y2: 13.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.d75848a49ac40e421e45d3d0f2992e3b.svg";
export { ForwardRef as ReactComponent };